<template>
  <a-spin :spinning="loading" :delay="500" size="large">
    <div class="detail-container">
      <Transition name="fade" appear mode="out-in">
        <div class="top" v-if="docState === 'top'" key="top">
          <div class="card">
            <div class="card__avatar" v-if="details.photoUrl">
              <img class="img" :src="details.photoUrl" alt="" />
            </div>
            <div
              class="card__title"
              v-if="details.idCardType >= 0 || details.idCardType >= 6"
            >
              {{ getIdCardType(details.idCardType) }}
            </div>
            <div class="card__subtitle" v-if="details.idCardNumber">
              {{ encryptIdCard(details.idCardNumber) }}
            </div>
            <div class="card__subtitle" v-if="details.mobile">
              {{ encryptPhone(details.mobile) }}
            </div>
            <div class="card__subtitle">
              {{ details.name }}
            </div>
            <div class="card__subtitle code">
              {{ details.certificateCode }}
            </div>
            <div class="card__wrapper">
              <a-tag color="#cd201f" v-if="details.isDelete === '1'">
                已销毁
              </a-tag>
              <a-tag color="#87d068" v-if="details.authenticated === 1">
                认证通过
              </a-tag>
              <a-tag color="#55acee" v-if="details.activated === 1">
                激活通过
              </a-tag>
            </div>
          </div>
          <hr style="margin-top: 10px" />
          <div class="actions">
            <div class="post-card">
              <div id="first" class="button-row">
                <button
                  class="button-row__item"
                  @click="actionSubmit('销毁证件', 1)"
                >
                  销毁证件
                </button>
                <button
                  class="button-row__item"
                  @click="actionSubmit('遗失重补', 2)"
                >
                  遗失重补
                </button>
                <button
                  class="button-row__item"
                  @click="actionSubmit('删除人像', 3)"
                >
                  删除人像
                </button>
              </div>
              <div id="second" class="button-row">
                <button
                  class="button-row__item"
                  @click="actionSubmit('重置实名', 4)"
                >
                  重置实名
                </button>
                <button
                  class="button-row__item"
                  @click="actionSubmit('重置激活', 5)"
                >
                  重置激活
                </button>
                <button
                  class="button-row__item"
                  @click="actionSubmit('二次同步', 7)"
                >
                  二次同步
                </button>
              </div>
              <button class="post" @click="docState = 'bottom'">
                修改数据
              </button>
            </div>
          </div>
        </div>
        <div class="bottom" v-if="docState === 'bottom'" key="bottom">
          <div class="modify">
            <div class="card1">
              <div class="form">
                <div class="group" style="margin-bottom: 15px">
                  <UploadImage :value.sync="details.photoUrl" />
                </div>
                <div class="group">
                  <input
                    v-model="details.certificateName"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">身份类型</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.certificateNameEn"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">身份类型英文</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.company"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">企业名称</label>
                </div>
                <div class="group">
                  <input v-model="details.name" placeholder="‎" type="text" />
                  <label for="name">姓名</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.department"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">部门</label>
                </div>
                <div class="group">
                  <input v-model="details.title" placeholder="‎" type="text" />
                  <label for="name">职务</label>
                </div>
                <div class="group">
                  <input v-model="details.mobile" placeholder="‎" type="text" />
                  <label for="name">手机号</label>
                </div>
                <div class="group">
                  <input v-model="details.email" placeholder="‎" type="text" />
                  <label for="name">邮箱</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.boothNo"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">展位号</label>
                </div>
                <div class="group">
                  <label for="dropdown">身份证件类型</label>
                  <select
                    v-model="details.idCardType"
                    id="dropdown"
                    name="dropdown"
                  >
                    <option :value="0">大陆居民身份证</option>
                    <option :value="1">外籍旅客护照</option>
                    <option :value="2">台湾居民来往大陆通行证</option>
                    <option :value="3">港澳居民来往内地通行证</option>
                    <option :value="4">港澳同胞回乡证</option>
                    <option :value="5">外国人永久居留身份证</option>
                    <option :value="6">其他类型证件</option>
                  </select>
                </div>
                <div class="group">
                  <input
                    v-model="details.idCardNumber"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">身份证件号码</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.reserve1"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">备注1</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.reserve2"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">备注2</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.reserve3"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">备注3</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.reserve4"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">备注4</label>
                </div>
                <div class="group">
                  <input
                    v-model="details.reserve5"
                    placeholder="‎"
                    type="text"
                  />
                  <label for="name">备注5</label>
                </div>
                <button type="submit" @click="submitSave">保存</button>
              </div>
            </div>
          </div>
        </div>
      </Transition>
      <hr style="margin-top: 10px" />
      <div class="footer">
        <button class="btn-class-name" @click="back">
          <span class="back"></span>
          <span class="front">返回</span>
        </button>
      </div>
    </div>
  </a-spin>
</template>

<script>
import {
  encryptIdCard,
  encryptPhone,
  getIdCardType,
  isValidIdCard,
} from "@/utils/util";
import Modal from "ant-design-vue/lib/modal/Modal";
import UploadImage from "../../../components/UploadImage.vue";
export default {
  components: { UploadImage },
  data() {
    return {
      details: {},
      docState: "top",
      loading: false,
    };
  },
  mounted() {
    const { rid } = this.$route.query;
    this.getRegistrationDetails(rid);
  },
  methods: {
    encryptIdCard,
    encryptPhone,
    getIdCardType,
    actionSubmit(content, operationType) {
      const _that = this;
      Modal.confirm({
        centered: true,
        title: "提示",
        content: `确定要${content}？`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          _that.loading = true;
          const { id } = _that.details;
          _that
            .$post("/api/Quick/Operations", { id, operationType })
            .then((res) => {
              if (res.code === 200 && res.success) {
                const { operationType } = res.data;
                _that.updateDetailsBasedOnOperation(operationType);
                _that.$message.success(`${content}成功`);
                _that.docState = "top";
              }
            })
            .finally(() => {
              _that.loading = false;
            });
        },
      });
    },
    updateDetailsBasedOnOperation(operationType) {
      switch (operationType) {
        case 1:
          this.details.isDelete = "1";
          break;
        case 3:
          this.details.photoUrl = null;
          break;
        case 4:
          this.details.authenticated = 0;
          break;
        case 5:
          this.details.activated = 0;
          break;
      }
    },
    getRegistrationDetails(rid) {
      this.$get(`/api/Quick/RegistrationDetails?id=${rid}`).then((res) => {
        if (res.code === 200 && res.success) {
          this.details = { ...res.data };
        }
      });
    },
    back() {
      this.$router.back();
    },
    // 保存
    submitSave() {
      const { idCardType, name, idCardNumber } = this.details;
      if (idCardType === 0) {
        if (!name || name === "") {
          this.$message.error("请输入姓名");
          return;
        }
        if (!idCardNumber || idCardNumber === "") {
          this.$message.error("请输入身份证件号码");
          return;
        }
        if (!isValidIdCard(idCardNumber)) {
          this.$message.error("请输入正确的身份证件号码");
          return;
        }
      }
      this.loading = true;
      // console.log(this.details, "details");
      this.$put("/api/Quick/UpdateRegistrationProfile", this.details)
        .then((res) => {
          if (res.code === 200 && res.success) {
            this.$message.success("保存成功");
            this.docState = "top";
            const { rid } = this.$route.query;
            this.getRegistrationDetails(rid);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.detail-container {
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
}

::v-deep(.avatar-uploader) {
  .ant-upload {
    border-color: rgba(0, 0, 0, 0.2) !important;
  }
}

.card {
  --main-color: #000;
  --submain-color: #78858f;
  --bg-color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  background: url(../../../assets/img/bg.png) no-repeat;
  background-position: left bottom;
  background-size: 100% 100%;
  padding: 10px;
  box-sizing: border-box;

  &__avatar {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: calc(50% - 57px);
    .img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  &__title {
    margin-top: 10px;
    font-weight: 500;
    font-size: 18px;
    color: var(--primary-color);
  }

  &__subtitle {
    margin-top: 3px;
    font-weight: 400;
    font-size: 15px;
    color: var(--submain-color);
  }

  .code {
    color: var(--primary-color);
    font-size: 13px;
    font-weight: 500;
  }

  &__btn {
    margin-top: 15px;
    width: 76px;
    height: 31px;
    border: 2px solid var(--main-color);
    border-radius: 4px;
    font-weight: 700;
    font-size: 11px;
    color: var(--main-color);
    background: var(--bg-color);
    text-transform: uppercase;
    transition: all 0.3s;
  }

  &__wrapper {
    margin-top: 10px;
  }
}

hr {
  border: 1px solid var(--primary-color);
  width: 100%;
  border-radius: 10em;
}

.actions {
  margin-top: 10px;
  width: 100%;

  .post-card {
    width: 100%;
    background: #fff;
    padding: 10px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    #first > button {
      background-color: #ff4851;
    }

    #second > button {
      margin-top: 7px;
      background-color: #ffb34a;
    }
  }

  .button-row {
    width: 100%;
    display: flex;
    gap: 30px;
    margin-top: 7px;
    margin-bottom: 3px;
    &__item {
      flex: 1;
    }
  }

  .button-row button {
    border-radius: 8px;
    border: none;
    height: 40px;
    font-family: Sans-serif;
    color: #fff;
    font-size: 16px;
    box-shadow: 0px 4px 4px #bdbdbd;
    transition: all 0.3s ease-in-out;
    @media screen and (max-width: 768px) {
      transition: all 0.1s ease-in-out;
    }
  }

  @media screen and (min-width: 768px) {
    .button-row button:hover {
      transform: translateY(-5px);
      box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25);
    }
  }

  @media screen and (max-width: 768px) {
    .button-row button:active {
      transform: translateY(5px);
      box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25);
    }
  }

  .post {
    width: 100%;
    padding: 10px;
    margin-top: 20px;
    border: none;
    border-radius: 11px;
    font-size: 18px;
    font-family: Sans-serif;
    color: #fff;
    background-size: 200% 100%;
    background-color: var(--primary-color);
    transition: 0.3s ease-out;
  }

  .post:hover {
    background-position: 99%;
  }
}

.footer {
  widows: 100%;
  position: relative;
  margin: 30px 0;
  text-align: center;
  .btn-class-name {
    --primary: 0, 48, 172;
    --secondary: 0, 48, 172;
    width: 60px;
    height: 50px;
    border: none;
    outline: none;
    cursor: pointer;
    user-select: none;
    touch-action: manipulation;
    outline: 10px solid rgb(var(--primary), 0.5);
    border-radius: 100%;
    position: relative;
    transition: 0.3s;
  }

  .btn-class-name .back {
    background: rgb(var(--secondary));
    border-radius: 100%;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .btn-class-name .front {
    background: linear-gradient(
      0deg,
      rgba(var(--primary), 0.6) 20%,
      rgba(var(--primary)) 50%
    );
    box-shadow: 0 0.5em 1em -0.2em rgba(var(--secondary), 0.5);
    border-radius: 100%;
    position: absolute;
    border: 1px solid rgb(var(--secondary));
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 600;
    font-family: inherit;
    transform: translateY(-15%);
    transition: 0.15s;
    color: #fff;
  }

  .btn-class-name:active .front {
    transform: translateY(0%);
    box-shadow: 0 0;
  }
}

.modify {
  width: 100%;
  // height: 80px;
  .card1 {
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }

  .form {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }

  .group {
    position: relative;
  }

  .form .group label {
    font-size: 14px;
    color: rgb(99, 102, 102);
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: #fff;
    transition: all 0.3s ease;
  }

  .form .group input,
  .form .group textarea,
  .form .group select {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
    outline: 0;
    width: 100%;
    background-color: transparent;
  }

  .form .group input:placeholder-shown + label,
  .form .group textarea:placeholder-shown + label,
  .form .group select:placeholder-shown + label {
    top: 10px;
    background-color: transparent;
  }

  .form .group input:focus,
  .form .group textarea:focus,
  .form .group select:focus {
    border-color: #3366cc;
  }

  .form .group input:focus + label,
  .form .group textarea:focus + label,
  .form .group select:focus + label {
    top: -10px;
    left: 10px;
    background-color: #fff;
    color: #3366cc;
    font-weight: 600;
    font-size: 14px;
  }

  .form .group textarea {
    resize: none;
    height: 100px;
  }

  .form button {
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .form button:hover {
    background-color: #27408b;
  }
}

.fade-enter-active {
  transition: all 0.8s;
}
/** 移除过程 **/
.fade-leave-active {
  transition: all 0.1s;
}
/*** 开始插入、移除结束的位置变化 ***/

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-450px);
}
</style>
